module.exports = __webpack_public_path__ + "static/img/6_v2.72423b6e.png";